import {DESKTOP, LARGE_DESKTOP, PHONE, PHONE_LANDSCAPE, TABLET} from "@irati/ui/src/global/media"

export const sliderSettings = {
  slidesToShow: 6,
  slidesToScroll: 6,
  responsive: [
    {breakpoint: PHONE, settings: {slidesToShow: 2.2, slidesToScroll: 2.2}},
    {breakpoint: PHONE_LANDSCAPE, settings: {slidesToShow: 3, slidesToScroll: 3}},
    {breakpoint: TABLET, settings: {slidesToShow: 4, slidesToScroll: 4}},
    {breakpoint: DESKTOP, settings: {slidesToShow: 4, slidesToScroll: 4}},
    {breakpoint: LARGE_DESKTOP, settings: {slidesToShow: 5, slidesToScroll: 5}}
  ]
}

export const categorySliderSettings = {
  slidesToShow: 8,
  slidesToScroll: 6,
  responsive: [
    {breakpoint: PHONE, settings: {slidesToShow: 2.2, slidesToScroll: 2.2}},
    {breakpoint: PHONE_LANDSCAPE, settings: {slidesToShow: 3, slidesToScroll: 3}},
    {breakpoint: TABLET, settings: {slidesToShow: 4, slidesToScroll: 4}},
    {breakpoint: DESKTOP, settings: {slidesToShow: 4, slidesToScroll: 4}},
    {breakpoint: LARGE_DESKTOP, settings: {slidesToShow: 5, slidesToScroll: 5}}
  ]
}
